<template>
  <div>
    <h4 class="hide-on-small-only">
      {{ id ? "Editar Questionário" : "Novo Questionário" }}
    </h4>
    <div class="card-panel" style="margin-bottom:24px">
      <form @submit.prevent="save">
        <div class="row">
          <div class="col s12" style="padding: 0 !important">
            <div class="row">
              <div class="input-field col s12 m6">
                <label for="name">Titulo</label>
                <input
                  type="text"
                  name="title"
                  id="name"
                  v-model="form.name"
                  v-validate="'required'"
                  :class="{ invalid: errors.first('title') }"
                />
                <span
                  class="helper-text"
                  :data-error="errors.first('title')"
                ></span>
              </div>
              <div class="input-field col s12 m6">
                <select v-model="form.customer.uuid">
                  <option value disabled selected>Selecione um cliente</option>
                  <option
                    :value="customer.uuid"
                    v-for="customer in customers"
                    :key="customer.uuid"
                    >{{ customer.company_name }}</option
                  >
                </select>
                <span
                  class="helper-text"
                  v-show="formErros.customer"
                  style="color: #F44336;"
                  >{{ formErros.customer }}</span
                >
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12">
                <label for="start_message">Saudação Inicial</label>
                <textarea
                  type="text"
                  name="start_message"
                  id="start_message"
                  v-model="form.start_message"
                  v-validate="'required'"
                  class="materialize-textarea"
                  :class="{ invalid: errors.first('start_message') }"
                />
                <span
                  class="helper-text"
                  :data-error="errors.first('start_message')"
                ></span>
              </div>
              <div class="col s12">
                <VToggle
                  label="Mostrar fundo do logo com tema escuro"
                  :checked="this.form.dark_mode"
                  @input="onChangeDarkMode"
                />
              </div>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <div class="box-search-question">
                  <div class="input-field box-search">
                    <label for="search-question">Buscar Questão</label>
                    <input
                      type="text"
                      name="search-question"
                      id="search-question"
                      v-model="searchText"
                    />
                    <i class="material-icons">search</i>
                    <span
                      class="helper-text"
                      v-show="formErros.question"
                      style="color: #F44336;"
                      >{{ formErros.question }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="container-questions" v-if="largeScreenAndUp">
              <div class="box-questions">
                <div>
                  <div class="card-column-header">
                    <span class="column-drag-handle">&#x2630;</span>
                    Questões
                  </div>
                  <Container
                    group-name="col"
                    @drop="e => onCardDrop('column-1', e)"
                    @drag-end="clearSearchText"
                    :get-child-payload="getCardPayload('column-1')"
                    drag-class="card-ghost"
                    drop-class="card-ghost-drop"
                    :drop-placeholder="dropPlaceholderOptions"
                  >
                    <Draggable
                      v-for="question in searchQuestions"
                      :key="question.uuid"
                    >
                      <div class="card">
                        <p><b>Titulo: </b>{{ question.question }}</p>
                        <p>
                          <b>Tipo de reposta: </b
                          >{{ getTypeQuestion(question.type_response) }}
                        </p>
                        <div
                          v-show="
                            question.response && question.response.length > 0
                          "
                        >
                          <div class="divider" />
                          <p><b>Respostas:</b></p>
                          <p v-if="question.type_response === 'LINER_SCALE'">
                            {{ question.response[0] }} <b>a</b>
                            {{ question.response[1] }}
                          </p>
                          <div v-else>
                            <p v-for="resp in question.response" :key="resp">
                              {{ resp }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Draggable>
                  </Container>
                </div>
              </div>
              <div class="box-questions">
                <div>
                  <div class="card-column-header">
                    <span class="column-drag-handle">&#x2630;</span>
                    Questões Selecionadas
                  </div>
                  <Container
                    group-name="col"
                    @drop="e => onCardDrop('column-2', e)"
                    @drag-end="clearSearchText"
                    :get-child-payload="getCardPayload('column-2')"
                    drag-class="card-ghost"
                    drop-class="card-ghost-drop"
                    :drop-placeholder="dropPlaceholderOptions"
                  >
                    <Draggable
                      v-for="question in form.questions"
                      :key="question.uuid"
                    >
                      <div class="card">
                        <p><b>Titulo: </b>{{ question.question }}</p>
                        <p>
                          <b>Tipo de reposta: </b
                          >{{ getTypeQuestion(question.type_response) }}
                        </p>
                        <div
                          v-show="
                            question.response && question.response.length > 0
                          "
                        >
                          <div class="divider" />
                          <p><b>Respostas:</b></p>
                          <p v-if="question.type_response === 'LINER_SCALE'">
                            {{ question.response[0] }} <b>a</b>
                            {{ question.response[1] }}
                          </p>
                          <div v-else>
                            <p v-for="resp in question.response" :key="resp">
                              {{ resp }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Draggable>
                  </Container>
                </div>
              </div>
            </div>
            <div class="container-questions-mb" v-else>
              <div
                class="card-question-mb"
                v-for="question in searchQuestions"
                :key="question.uuid"
                @click="addQuestionMb(question)"
              >
                <div class="indicator" v-show="checkQuestionSelect(question)">
                  <p>{{ checkQuestionSelect(question) }}</p>
                </div>
                <p><b>Titulo: </b>{{ question.question }}</p>
                <p>
                  <b>Tipo de reposta: </b
                  >{{ getTypeQuestion(question.type_response) }}
                </p>
                <div v-show="question.response && question.response.length > 0">
                  <div class="divider" />
                  <p><b>Respostas:</b></p>
                  <p v-if="question.type_response === 'LINER_SCALE'">
                    {{ question.response[0] }} <b>a</b>
                    {{ question.response[1] }}
                  </p>
                  <div v-else>
                    <p v-for="resp in question.response" :key="resp">
                      {{ resp }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if=id class="row">
            <p>Link para questionário externo: <a :href=qrcodeurl> {{ qrcodeurl }}</a></p>
            <QrCodeQuiz :url=qrcodeurl />
        </div>
        <div class="actions">
          <router-link
            class="waves-effect btn-large flat form-button"
            stag="a"
            :to="{ name: 'quizzes' }"
            >voltar</router-link
          >
          <div class="spacer"></div>
          <button
            class="waves-effect waves-light btn-large form-button"
            type="submit"
            :class="{ load: load }"
          >
            <feather v-if="load" type="loader" animation="spin" />
            <template v-else>{{ id ? "salvar" : "Cadastrar" }}</template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import mediaQuery from "@/services/mixins/mediaQuery";
import { mapState } from "vuex";
import QrCodeQuiz from "../../components/QrCodeQuiz.vue";

export default {
  name: "CreateOrUpdateForm",
  mixins: [mediaQuery],
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  components: {
    Container,
    Draggable,
    VToggle: () => import("@/components/VToggle"),
    QrCodeQuiz
},
  data: () => ({
    formErros: {
      customer: "",
      question: ""
    },
    searchText: "",
    dropPlaceholderOptions: {
      className: "drop-preview",
      animationDuration: "150",
      showOnTop: true
    },
    instanceSelect: {},
    searchQuestion: "",
    load: false,
    customers: [],
    questions: [],
    form: {
      customer: {
        uuid: ""
      },
      start_message: "",
      name: "",
      questions: [],
      dark_mode: false
    }
  }),
  async mounted() {
    const loader = this.$loading.show({
      loader: "spinner",
      width: 50,
      backgroundColor: "#000",
      color: "#fff"
    });

    await this.getCustomers();
    const el = this.$el.querySelectorAll("select");
    this.instanceSelect = M.FormSelect.init(el);
    await this.getQuestions();

    if (this.id) {
      await this.getQuiz();
    }

    loader.hide();
  },
  computed: {
    ...mapState("User", ["token"]),
    qrcodeurl() { 
      const route = this.$router.resolve({ name: "response-externo", params: { id: this.id } });
      return window.location.origin + route.href;
    },
    searchQuestions() {
      if (this.searchText) {
        return this.questions.filter(val =>
          val.question.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      return this.questions;
    }
  },
  watch: {
    "form.customer.uuid"(value) {
      if (value) {
        this.formErros.customer = "";
      }
    },
    "form.questions"(value) {
      if (value.length > 1) {
        this.formErros.question = "";
      }
    }
  },
  methods: {
    async save() {
      if (this.form.questions.length < 2) {
        this.formErros.question = "Selecione/Adicione no minimo 2 questões";
      }
      if (this.form.customer.uuid === "") {
        this.formErros.customer = "Preenchimento Obrigatório";
      }

      await this.$validator.validateAll();

      if (
        !this.errors.items.length > 0 &&
        this.formErros.question === "" &&
        this.formErros.customer === ""
      ) {
        const form = { ...this.form };

        form.questions = form.questions.map(val => val.uuid);

        this.load = true;
        let msg = "";
        try {
          if (!this.id) {
            await this.$http.post(
              "quizzes",
              {
                quiz: form
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );

            msg = "Questionário cadastrado com sucesso";
          } else {
            await this.$http.post(
              `quizzes/${this.id}`,
              {
                quiz: form
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );
            msg = "Questionário editado com sucesso";
          }

          this.$swal({
            title: "Pronto!",
            text: msg,
            icon: "success",
            button: "Continuar"
          }).then(val => {
            this.$router.push({ name: "quizzes" });
          });
        } catch (e) {
          M.toast({
            html: e.body.message.replace("name", "Titulo"),
            displayLength: 5000
          });
        }

        this.load = false;
      }
    },
    onChangeDarkMode(dark_mode) {
      this.form.dark_mode = dark_mode;
    },
    async getQuiz() {
      try {
        const resp = await this.$http.get(`quizzes?search=uuid:${this.id}`);

        const [quiz] = resp.body.data.quizzes;

        this.instanceSelect[0].destroy();
        this.form.customer.uuid = quiz.customer.uuid;
        this.form.name = quiz.name;
        this.form.start_message = quiz.start_message;
        setTimeout(() => {
          const el = this.$el.querySelectorAll("select");
          this.instanceSelect = M.FormSelect.init(el);

          const labels = ["name", "start_message"];

          labels.forEach(val => {
            if (this.form[val]) {
              this.$el
                .querySelector(`label[for="${val}"]`)
                .classList.add("active");
            }
          });
        }, 0);

        this.form.questions = quiz.questions;

        if (this.largeScreenAndUp) {
          this.questions = this.questions.filter(
            question =>
              !quiz.questions.some(value => value.uuid === question.uuid)
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getCustomers() {
      try {
        const response = await this.$http.get("customers?search=active:1");
        this.customers = response.body.data.customers;
      } catch (e) {
        console.error(e);
      }
    },
    async getQuestions() {
      try {
        const response = await this.$http.get("questions?search=active:1");
        this.questions = response.body.data.questions;
      } catch (e) {
        console.error(e);
      }
    },
    onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex === null && dropResult.addedIndex !== null) {
        if (columnId === "column-1") {
          if (this.questions.indexOf(dropResult.payload) === -1) {
            this.questions.push(dropResult.payload);
          }
        }
        if (columnId === "column-2") {
          if (this.form.questions.indexOf(dropResult.payload) === -1) {
            this.form.questions.push(dropResult.payload);
          }
        }
      }

      if (dropResult.addedIndex === null && dropResult.removedIndex !== null) {
        if (columnId === "column-1") {
          this.questions = this.questions.filter(
            val => val.uuid !== dropResult.payload.uuid
          );
        }
        if (columnId === "column-2") {
          this.form.questions = this.form.questions.filter(
            val => val.uuid !== dropResult.payload.uuid
          );
        }
      }

      if (dropResult.removedIndex !== null && dropResult.addedIndex !== null) {
        if (columnId === "column-1") {
          const questions1 = [...this.questions];
          this.questions = this.applyDrag(questions1, dropResult);
        }

        if (columnId === "column-2") {
          const questions2 = [...this.form.questions];
          this.form.questions = this.applyDrag(questions2, dropResult);
        }
      }
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      const itemToAdd = payload;

      if (removedIndex !== null) {
        result.splice(removedIndex, 1);
      }

      if (addedIndex !== null && removedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },
    getCardPayload(columnId) {
      if (columnId === "column-2") {
        return index => this.form.questions[index];
      }

      return index => this.searchQuestions[index];
    },
    checkQuestionSelect(question) {
      let position = null;

      this.form.questions.forEach((value, index) => {
        if (value.uuid === question.uuid) {
          position = index;
        }
      });

      return position !== null ? position + 1 : null;
    },
    addQuestionMb(question) {
      if (this.form.questions.some(val => val.uuid === question.uuid)) {
        this.form.questions = this.form.questions.filter(
          val => val.uuid !== question.uuid
        );
      } else {
        this.form.questions.push(question);
      }

      this.clearSearchText();
    },
    getTypeQuestion(type) {
      const typesResponse = [
        {
          id: 1,
          value: "BOOLEAN",
          title: "Condicional (Sim ou Não)"
        },
        {
          id: 2,
          value: "SHORT_ANSWER",
          title: "Resposta curta"
        },
        {
          id: 3,
          value: "LONG_ANSWER",
          title: "Parágrafo"
        },
        {
          id: 4,
          value: "CHOICES",
          title: "Caixas de seleção"
        },
        {
          id: 5,
          value: "CHECK_BOXES",
          title: "Múltipla escolha"
        },
        {
          id: 6,
          value: "LINER_SCALE",
          title: "Escala linear"
        },
        {
          id: 7,
          value: "DROPDOWN",
          title: "Lista suspensa"
        }
      ];

      return typesResponse.filter(val => val.value === type)[0].title;
    },
    clearSearchText() {
      this.searchText = "";

      this.$el
        .querySelector('label[for="search-question"]')
        .classList.remove("active");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.container-questions {
  display: flex;
  width: 100%;

  margin-bottom: 40px;
  .box-questions {
    flex: 1;
    background: #f3f3f3;
    padding: 10px;
    border-radius: 6px;
    height: 100%;
    max-height: 500px;

    overflow: auto;

    &:first-child {
      margin-right: 16px;
    }
  }
}

.box-search {
  i {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #757575;
  }
}

.animated {
  animation-duration: 0.5s;
}

.row {
  margin-bottom: 0 !important;
}
.actions {
  display: flex;
  justify-content: flex-end;
  .spacer {
    width: 16px;
    height: 24px;
  }

  @media #{$small-and-down} {
    flex-direction: column-reverse;
  }
}
.box-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    margin-bottom: 16px;
    width: 200px;

    @media #{$small-and-down} {
      width: 100%;
    }
  }
}
.border-error {
  border: 2.4px solid #f44336;
}

/// Mobile
.container-questions-mb {
  display: flex;
  flex-direction: column;
  position: relative;

  .card-question-mb {
    background-color: white;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);
    padding: 10px;
    margin-bottom: 15px;
  }

  .indicator {
    position: absolute;
    right: 10px;
    height: 30px;
    width: 30px;
    background: #10d810;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      color: #fff;
    }
  }
}
</style>
